import { Component } from '@angular/core';

import { ComponentBase } from '@definitiv-packages/angular-dba-library';

import { AppService, ProjectLanguage } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-verwaltung-main-view',
  templateUrl: './verwaltung-main-view.component.html',
  styleUrls: ['./verwaltung-main-view.component.scss'],
  standalone: false
})
export class VerwaltungMainViewComponent extends ComponentBase<ProjectLanguage> {
  constructor(
    public appService: AppService
  ) { super(); }
}